import React from 'react';
import '../styles/Footer.css';
import { FaPhoneAlt, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="footer-overlay">

        <div className="footer-column">
          <h4>COMPANY</h4>
          <ul>
            <li><a href="/aboutus">About Us</a></li>
            <li><a href="/contactpg">Careers</a></li>
            <li><a href="/contactpg">Contact Us</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>SERVICES</h4>
          <ul>
            
            <li><a href="/servicepg">Website Design</a></li>
            <li><a href="/manpowerpg">Manpower Outsourcing</a></li>
            <li><a href="/gstpg">Gst Registration</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>CONTACT</h4>
          <ul>
            <li>
              <FaPhoneAlt className="footer-icon" />
              <a href="tel:+91 8925288802"> +91 8925288802</a>
            </li>
            <li>
              <FaEnvelope className="footer-icon" />
              <a href="mailto:hr@matrixconsultancy.in">hr@matrixconsultancy.in</a>
            </li>
          </ul>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
